import { TextProps } from 'antd/lib/typography/Text';
import { Text as TextComponent } from 'components';
import { theme } from 'configs/styled';
import React from 'react';

export interface ITextBoldProps extends TextProps {
  fontSize?: string;
  color?: string;
  margin?: string;
  display?: string;
}

const TextBold: React.FC<ITextBoldProps> = ({
  color = theme.palettes.black60,
  fontSize = theme.fontSize.xs,
  margin = '0px 3px',
  display = 'inline',
  ...props
}) => {
  return (
    <TextComponent
      {...props}
      style={{
        fontWeight: theme.fontWeight.bold,
        fontStyle: 'normal',
        fontSize,
        lineHeight: '22px',
        margin,
        color,
        display,
      }}
    />
  );
};

export default TextBold;
